import { transformV4 } from './transform-v4'
import { transformV3 } from './transform-v3'
import { transformV2 } from './transform-v2'

/**
 * Utility function to extract safety information from URL string
 * @param url URL string
 * @returns SafetyInformationV3
 */
export const getMedicalIdFromUrl = (urlString: string) => {
  const url = new URL(urlString)
  const version = url.searchParams.get('v')

  if (version === '4') {
    return transformV4(urlString)
  } else if (version === '3') {
    return transformV3(urlString)?.medicalId
  } else {
    return transformV2(urlString)
  }
}
